export const ORGANIZATION_SHOW_TABS = [
  'general',
  'publishers',
  'members',
  'contracts',
] as const;
export type OrganizationShowTab = (typeof ORGANIZATION_SHOW_TABS)[number];
export const ORGANIZATION_DEFAULT_TAB: OrganizationShowTab = 'general';
